export enum RoleLevel {
  SISADM = 1,
  ADMIN = 2,
  PARTNER = 3,
  ANALYST = 4
}

export const RolesString = {
  SISADM: 'Administrador do Sistema',
  ADMIN: 'Administrativo',
  PARTNER: 'Partner',
  ANALYST: 'Analista',
}
